export const FETCH_FAVORITES = 'FETCH_FAVORITES';
export const FETCH_FAVORITES_SUCCEED = 'FETCH_FAVORITES_SUCCEED';
export const FETCH_FAVORITES_FAILED = 'FETCH_FAVORITES_FAILED';

export const FETCH_UPDATE_FAVORITES = 'FETCH_UPDATE_FAVORITES';
export const FETCH_UPDATE_FAVORITES_SUCCEED = 'FETCH_UPDATE_FAVORITES_SUCCEED';
export const FETCH_UPDATE_FAVORITES_FAILED = 'FETCH_UPDATE_FAVORITES_FAILED';

export const FETCH_DELETE_FAVORITES = 'FETCH_DELETE_FAVORITES';
export const FETCH_DELETE_FAVORITES_SUCCEED = 'FETCH_DELETE_FAVORITES_SUCCEED';
export const FETCH_DELETE_FAVORITES_FAILED = 'FETCH_DELETE_FAVORITES_FAILED';

export const LOCAL_FETCH_FAVORITES = 'LOCAL_FETCH_FAVORITES';
export const LOCAL_FETCH_FAVORITES_SUCCEED = 'LOCAL_FETCH_FAVORITES_SUCCEED';
export const LOCAL_FETCH_FAVORITES_FAILED = 'LOCAL_FETCH_FAVORITES_FAILED';

export const LOCAL_FETCH_UPDATE_FAVORITES = 'LOCAL_FETCH_UPDATE_FAVORITES';
export const LOCAL_FETCH_UPDATE_FAVORITES_SUCCEED = 'LOCAL_FETCH_UPDATE_FAVORITES_SUCCEED';
export const LOCAL_FETCH_UPDATE_FAVORITES_FAILED = 'LOCAL_FETCH_UPDATE_FAVORITES_FAILED';

export const LOCAL_FETCH_DELETE_FAVORITES = 'LOCAL_FETCH_DELETE_FAVORITES';
export const LOCAL_FETCH_DELETE_FAVORITES_SUCCEED = 'LOCAL_FETCH_DELETE_FAVORITES_SUCCEED';
export const LOCAL_FETCH_DELETE_FAVORITES_FAILED = 'LOCAL_FETCH_DELETE_FAVORITES_FAILED';
